import { Box } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import TableComponent from 'UiKit/table-component';
import useGetLiveAccount from 'Domain/live-account/useGetLiveAccount';
import { Condition } from 'Component/others';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import TableSkeleton from 'View/live-account/component/tableSkeleton';
import { useLiveAccountState } from 'View/live-account/state';

import buildTableList from './const';
import styles from './styles.module.css';

const Table = () => {
  const { t } = useTranslation('live-account');
  const accessPermission = getMenuPermissions('master-data', 'account-livestream');
  const tableList = buildTableList(t);
  const { updateState, updateFilterState, filterState } = useLiveAccountState();
  const { data, isLoading } = useGetLiveAccount(filterState);

  const onChangePagination = (page) => updateFilterState({ page });
  const onChangeSort = (sort) => updateFilterState({ sort });

  return (
    <Box className={styles['table__container']}>
      <Condition statement={!isLoading} fallback={<TableSkeleton />}>
        <Box className={styles['table__wrapper']}>
          <TableComponent
            isCanCreate={accessPermission?.isCanCreate}
            columns={tableList}
            dataSource={data?.liveAccounts}
            onSort={onChangeSort}
            sortingData={filterState?.sort}
            emptyActionText={t('createButton')}
            isDataExist={data?.isDataExist}
            onEmptyStateAction={() => updateState({ isOpenFormUpsert: true })}
            maxTableHeight="calc(100vh - 305px)"
            maxTableBodyHeight="calc(100vh - 404px)"
            tableComponentHeight="calc(100vh - 236px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: data?.totalData,
              onChange: onChangePagination,
              isLoading,
            }}
          />
        </Box>
      </Condition>
    </Box>
  );
};

const MemoizedTable = ({ ...props }) => useMemo(() => <Table {...props} /> /* eslint-disable */, []);

export default MemoizedTable;
